import { render, staticRenderFns } from "./Stpr.vue?vue&type=template&id=3b8819fe&scoped=true&"
import script from "./Stpr.vue?vue&type=script&lang=js&"
export * from "./Stpr.vue?vue&type=script&lang=js&"
import style0 from "./Stpr.vue?vue&type=style&index=0&id=3b8819fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8819fe",
  null
  
)

export default component.exports